import {
  Component,
  computed,
  effect,
  inject,
  untracked,
  ChangeDetectionStrategy,
} from "@angular/core";
import { TranslocoModule, TranslocoService } from "@jsverse/transloco";
import { JourneyBreadcrumb } from "../journey-breadcrumb/journey-breadcrumb";
import { Loader } from "src/app/shared/components/loader/loader";
import { JourneySearchStore } from "src/app/features/store/journey-search-store";
import { Button } from "src/app/shared/components/utils/button/button";
import { PianoAnalyticsService } from "src/app/core/services/piano-analytics";
import { ProgressionBar } from "../progression-bar/progression-bar";
import { Router } from "@angular/router";
import { ContactCard } from "src/app/shared/components/contact-card/contact-card";
import { ContactCardInterface } from "src/app/core/interfaces/contact-card-interface";
import { LanguageService } from "src/app/core/services/language-service";

@Component({
  selector: "app-hr-contact-journey-page",
  imports: [
    TranslocoModule,
    JourneyBreadcrumb,
    Loader,
    Button,
    ProgressionBar,
    ContactCard,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: "./hr-contact-journey-page.html",
})
export class HrContactJourneyPage {
  store = inject(JourneySearchStore);
  piano = inject(PianoAnalyticsService);
  private readonly translationService = inject(TranslocoService);
  private readonly languageService = inject(LanguageService);

  router = inject(Router);
  isJourneyImmature = computed(() => this.store.isJourneyImmature());
  loading = computed(() => this.store.contactRhLoading());
  hrContactList = computed(() => this.store.contactRhList());

  constructor() {
    effect(() => {
      this.languageService.currentLanguage();

      untracked(async () => {
        this.store.loadHrContact();
        if (!sessionStorage.getItem("piano_journey_end_sent")) {
          this.piano.sendEvent("journey.end", {});
          sessionStorage.setItem("piano_journey_end_sent", "true");
        }
      });
    });
  }

  redirectToJourneyResearch(): void {
    this.router.navigate(["/journey/search"]);
  }

  getPhotoUrl(hrContact: ContactCardInterface): string {
    if (hrContact?.photoUrl) {
      return hrContact.photoUrl;
    }

    return "assets/images/user/user-contact-card.png";
  }

  getHrContactFullName(hrContact: ContactCardInterface): string {
    if (hrContact) {
      return hrContact.firstName + " " + hrContact.lastName;
    } else {
      return this.translationService.translate("generic.notSpecified");
    }
  }

  getHrContactJob(hrContact: ContactCardInterface): string {
    if (hrContact?.job && hrContact.job.trim().length > 0) {
      return hrContact.job;
    } else {
      return this.translationService.translate("generic.notSpecified");
    }
  }

  getHrContactMail(hrContact: ContactCardInterface): string {
    if (hrContact) {
      return hrContact.mail;
    } else {
      return this.translationService.translate("generic.notSpecified");
    }
  }

  getHrContactPhoneNumber(hrContact: ContactCardInterface): string {
    if (hrContact) {
      return hrContact.phoneNumber;
    } else {
      return this.translationService.translate("generic.notSpecified");
    }
  }

  getHrContactEntity(hrContact: ContactCardInterface): string {
    if (hrContact.entity && hrContact.entity.trim().length > 0) {
      return hrContact.entity;
    }

    return this.translationService.translate("generic.notSpecified");
  }

  getHrContactBookingLink(hrContact: ContactCardInterface): string {
    return hrContact.bookingCalendarLink ?? "";
  }
}
